import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlSituacaoCronologia = '/service/contabilidade/ordemCronologicaPortal/'

class SituacaoCronologiaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getSituacaoCronologica() {
        return this.conex.get(urlSituacaoCronologia + 'situacaoCronologica/')
    }
}

export default SituacaoCronologiaService
